import axiosInstance from "auth/FetchInterceptor";
import {
    GET_THEME_SINH_NHAT,
    CREATE_THEME_SINH_NHAT,
    UPDATE_THEME_SINH_NHAT,
    DELETE_THEME_SINH_NHAT
} from "constants/ApiConstant";
const thietLapNoiBo = {};

thietLapNoiBo.createThemeSinhNhat = function (data) {
    return axiosInstance.post(`${CREATE_THEME_SINH_NHAT}`, data);
};

thietLapNoiBo.updateThemeSnhNhat = function (data) {
    return axiosInstance.put(`${UPDATE_THEME_SINH_NHAT}`, data);
};

thietLapNoiBo.getThemeSinhNhat = function () {
    return axiosInstance.get(`${GET_THEME_SINH_NHAT}`);
};

thietLapNoiBo.deleteThemeSinhNhat = function (id) {
    return axiosInstance.delete(`${DELETE_THEME_SINH_NHAT}/` + id);
};

export default thietLapNoiBo;
